import { render, staticRenderFns } from "./ImageMultipleOutline.vue?vue&type=template&id=9b56da8c"
import script from "./ImageMultipleOutline.vue?vue&type=script&lang=js"
export * from "./ImageMultipleOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports